import { reactive } from 'vue'

/**
 * Returns a reactive object which is useful for tracking the state of 
 * asynchronous operations.
 */

export interface AsyncState {
  status: 'ready' | 'busy' | 'error'
  error: null | string
  isBusy: () => boolean
  setBusy: () => void
  isError: () => boolean
  getError: () => null | string
  setError: (error: string) => void
  isReady: () => boolean
  setReady: () => void
}

export default function asyncStatus() {

  const state: AsyncState = {

    // Don't ever reference these properties directly! Use the is*() and set*()
    // methods instead.
    status: 'ready',
    error: null,

    isBusy(): boolean {
      return this.status === 'busy'
    },

    setBusy(): void {
      this.status = 'busy'
      this.error = null
    },

    isError(): boolean {
      return this.status === 'error'
    },

    getError(): null | string {
      return this.error
    },

    setError(error: string): void {
      this.error = error
      this.status = 'error'
    },

    isReady(): boolean {
      return this.status === 'ready'
    },

    setReady(): void {
      this.status = 'ready'
      this.error = null
    },

  }

  return reactive(state)

}
